import { useUser } from '@/hooks/use-user';
import { DealState } from '@/lib/graphql/generated/graphql';
import { dealStateState } from '@/states/deal-state.state';
import { editionModeState } from '@/states/edition-mode.state';
import { useAtomValue } from 'jotai';

/**
 * Offer is locked when:
 * - Brand user and main is not at Brand (editionMode !== Brand) → brand cannot edit
 * - Choose user and main is not at Choose (editionMode !== Choose) → choose cannot edit
 * - Workflow states: ValidatedByBoth or NegotiationClosed → nobody edits
 * Backend provides deal.editionMode (ActorRole) via GraphQL.
 */
export function useIsOfferLocked(): boolean {
  const user = useUser();
  const editionMode = useAtomValue(editionModeState);
  const dealState = useAtomValue(dealStateState);

  if (!user || !editionMode || !dealState) {
    return true;
  }

  const lockedByMode = user.role !== editionMode;

  const lockedByWorkflow = dealState === DealState.NegotiationClosed;

  return lockedByMode || lockedByWorkflow;
}
